module.exports = __webpack_public_path__ + "img/demo_landscaper-600x450.f186b9fb.jpg";